<template>
  <v-data-table
      :headers="headers1"
      :items="organizations"
      :items-per-page="itemsPerPage"
      item-key="organizationId"
      class="elevation-1"
      disable-sort-by
      dense
      hide-default-footer
      :locale="systemLocale">
    <template v-slot:top>
      <v-row>
        <v-col class="pr-4 mr-3">
          <v-combobox
              v-if="!readonly"
              v-model="current"
              :loading="isLoading"
              item-value="organizationId"
              item-text="organizationName"
              :items="filteredItems"
              :error-messages="errorMessages"
              :label="searchLabel"
              :readonly="readonly"
              :search-input.sync="search"
              :clearable="!readonly"
              prepend-icon="search"
              return-object
              eager
              dense
              @contextmenu.prevent>
            <template v-slot:prepend-inner>
              <v-icon
                  v-if="required"
                  small
                  left
                  :color="requiredColor">
                *
              </v-icon>
            </template>
            <template v-slot:append-outer>
              <btn-icon-tip
                  v-if="!readonly && canAdd"
                  id="addBtn"
                  :tip="$t('Добавить организацию')"
                  icon-color="addbtn"
                  icon="add"
                  @click="add" />
              <btn-icon-tip
                  v-if="!readonly && canClear"
                  id="clearBtn"
                  :tip="$t('Очистить список')"
                  icon="delete_sweep"
                  @click="clear" />
            </template>
          </v-combobox>
        </v-col>
      </v-row>
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.organizationName="{ item }">
      {{ item.organizationName }}
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.isLocked="{ item }">
      <icon-tip
          :icon="item.isLocked
            ? 'lock'
            : 'lock_open'"
          :icon-color="item.isLocked
            ? 'error'
            : 'success'"
          :tip="$t('Текущий статус: {0}', [ $t(item.isLocked
            ? 'Заблокирована'
            : 'Активная') ] )" />
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.organizationId="{ item }">
      <btn-icon-tip
          v-if="!readonly"
          :id="`deleteBtn-${item.organizationId}`"
          :tip="$t('Убрать из списка')"
          icon="cancel"
          @click="remove(item.organizationId)" />
    </template>
  </v-data-table>
</template>

<script>
  import BtnIconTip from './BtnIconTip.vue'
  import IconTip from './IconTip.vue'
  import { PARTICIPANT_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { ORGANIZATION_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      BtnIconTip,
      IconTip
    },
    props: {
      value: {
        type: Array,
        default: () => {
          return []
        }
      },
      exclude: {
        type: Array,
        default: () => {
          return []
        }
      },
      required: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      errorMessages: Array,
      label: {
        type: String,
        default: ''
      },
      searchLabel: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      params: {
        type: Object,
        default: () => ({
          participantType: PARTICIPANT_TYPES.ORGPART
        })
      }
    },
    data () {
      return {
        isLoading: false,
        itemsPerPage: -1,
        search: '',
        current: null,
        organizations: []
      }
    },
    computed: {
      ...mapState(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        items: state => (state[ORGANIZATION_MANAGEMENT.STATE.SHORT_INFO_LIST] || [])
      }),
      headers1 () {
        return [
          { text: this.label, sortable: true, value: 'organizationName' },
          { text: this.$t('Статус'), sortable: true, value: 'isLocked' },
          { text: '', sortable: false, value: 'organizationId' }
        ]
      },
      canAdd () {
        return this.current &&
          this.current.hasOwnProperty('organizationId') &&
          this.current.hasOwnProperty('organizationName')
      },
      canClear () {
        return this.organizations.length
      },
      filteredItems () {
        if (this.readonly) {
          return []
        }
        let filteredItems = this.items || []
        if (this.search &&
          (!this.canAdd || this.current.organizationName !== this.search)) {
          return filteredItems.filter(r => r.organizationName.toLowerCase().includes(this.search.toLowerCase()))
        }
        if (this.current && this.current.organizationId) {
          filteredItems = filteredItems.filter(o => o.organizationId !== this.current.organizationId)
        }
        if (this.exclude && this.exclude.length) {
          filteredItems = filteredItems.filter(o => !this.exclude.includes(o.organizationId))
        }
        if (this.organizations && this.organizations.length) {
          filteredItems = filteredItems.filter(o => !this.organizations.some(i => i.organizationId === o.organizationId))
        }

        return filteredItems
      }
    },
    watch: {
      search (pattern) {
        if (!pattern) {
          this.current = null
        }
      },
      value: {
        immediate: true,
        handler (newVal) {
          this.mapSelected(newVal)
        }
      },
      items: {
        immediate: true,
        handler (newVal) {
          if (newVal.length) {
            this.mapSelected(this.value)
          }
        }
      }
    },
    created () {
      // if (!this.items.length) {
      this.getOrganizationsShortInfoList()
      // }
    },
    methods: {
      ...mapActions(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        getOrganizationsShortInfoListAction: ORGANIZATION_MANAGEMENT.ACTIONS.GET_ORGANIZATIONS_SHORT_INFO_LIST
      }),
      mapSelected: function (newVal) {
        const vm = this
        // первичная инициализация, если в родительском компоненте заданы значения по умолчанию
        // либо изменение входных данных после загрузки с сервера
        if (newVal && newVal.length) {
          newVal.forEach(orgId => {
            const organization = vm.items.find(i => i.organizationId === orgId)
            if ((!vm.organizations.length ||
              !vm.organizations.some(o => o.organizationId === orgId)) &&
              organization) {
              vm.organizations.push(organization)
            }
          })
        } else {
          vm.organizations = []
        }
      },
      remove: function (id) {
        const orgs = this.organizations.filter(o => o.organizationId !== id)
        this.organizations = orgs
        this.input(this.organizations)
      },
      add: function () {
        if (!this.organizations.find(io => io.organizationId === this.current.organizationId)) {
          this.organizations.push(this.current)
          this.input(this.organizations)
        }
        this.current = null
      },
      input: function (organizations) {
        this.$emit('input', organizations.map(ps => ps.organizationId))
      },
      clear: function () {
        this.current = null
        this.organizations = []
        this.$emit('input', [])
      },
      getOrganizationsShortInfoList: async function () {
        try {
          this.isLoading = true
          await this.getOrganizationsShortInfoListAction(this.params)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
